export default __webpack_public_path__ + "static/media/rules_PFM_LINK.072fc6d8.pdf";